module.exports = __webpack_public_path__ + "ed4e23862af427101ef4c485cd84aaf1.png";